<div>
  <iframe [src]="twofacturl" style="width: 100%; height: 100vh;border:0px solid"></iframe>
</div>